export const RECONNECT_DEVICE_TIMEOUT = 15000;
export const ADVERTISING_DELAY = 400;
export const ADVERTISING_TIMEOUT = 1200;
export const REDISCOVER_TIMEOUT = 3000;
export const RECONNECTION_LOOP_BACKOFF = 500;
